export * from './account.service';
import { AccountService } from './account.service';
export * from './accountRepairer.service';
import { AccountRepairerService } from './accountRepairer.service';
export * from './adminEmail.service';
import { AdminEmailService } from './adminEmail.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './brand.service';
import { BrandService } from './brand.service';
export * from './caseDisplayError.service';
import { CaseDisplayErrorService } from './caseDisplayError.service';
export * from './category.service';
import { CategoryService } from './category.service';
export * from './contactLog.service';
import { ContactLogService } from './contactLog.service';
export * from './country.service';
import { CountryService } from './country.service';
export * from './customer.service';
import { CustomerService } from './customer.service';
export * from './customerCase.service';
import { CustomerCaseService } from './customerCase.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './deadline.service';
import { DeadlineService } from './deadline.service';
export * from './errorType.service';
import { ErrorTypeService } from './errorType.service';
export * from './language.service';
import { LanguageService } from './language.service';
export * from './message.service';
import { MessageService } from './message.service';
export * from './notification.service';
import { NotificationService } from './notification.service';
export * from './product.service';
import { ProductService } from './product.service';
export * from './purchaseOrder.service';
import { PurchaseOrderService } from './purchaseOrder.service';
export * from './purpose.service';
import { PurposeService } from './purpose.service';
export * from './repairerCase.service';
import { RepairerCaseService } from './repairerCase.service';
export * from './repairshop.service';
import { RepairshopService } from './repairshop.service';
export * from './repairshopCase.service';
import { RepairshopCaseService } from './repairshopCase.service';
export * from './report.service';
import { ReportService } from './report.service';
export * from './roleClaims.service';
import { RoleClaimsService } from './roleClaims.service';
export * from './serviceProviderCase.service';
import { ServiceProviderCaseService } from './serviceProviderCase.service';
export * from './systemMessage.service';
import { SystemMessageService } from './systemMessage.service';
export * from './testApi.service';
import { TestApiService } from './testApi.service';
export * from './userProduct.service';
import { UserProductService } from './userProduct.service';
export * from './utilities.service';
import { UtilitiesService } from './utilities.service';
export * from './vote.service';
import { VoteService } from './vote.service';
export * from './webhook.service';
import { WebhookService } from './webhook.service';
export const APIS = [AccountService, AccountRepairerService, AdminEmailService, AuthService, BrandService, CaseDisplayErrorService, CategoryService, ContactLogService, CountryService, CustomerService, CustomerCaseService, DashboardService, DeadlineService, ErrorTypeService, LanguageService, MessageService, NotificationService, ProductService, PurchaseOrderService, PurposeService, RepairerCaseService, RepairshopService, RepairshopCaseService, ReportService, RoleClaimsService, ServiceProviderCaseService, SystemMessageService, TestApiService, UserProductService, UtilitiesService, VoteService, WebhookService];
